export const getTranslations =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (translations: any) =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (language: string, key: string, format: any = null): string => {
      const messages = translations.getLoadedMessages(language);

      return messages ? messages[key].format(format) : 'Error';
    };
